export const GET_WORK = 'app/Works/GET_WORK';
export const GET_WORK_PERF_PAST = 'app/Works/GET_WORK_PERF_PAST';
export const GET_WORK_PERF_FUTURE = 'app/Works/GET_WORK_PERF_FUTURE';
export const GET_WORKS_PRODUCTIONS = 'app/Works/GET_PRODUCTIONS';
export const SET_WORKS_PERFORMANCES = 'app/Works/SET_PERFORMANCES';
export const GET_WORKS_PERFORMANCES = 'app/Works/GET_PERFORMANCES';
